// extracted by mini-css-extract-plugin
export default {"background":"kJ1IS","circle":"TScSU","skeleton":"_WyKD","button":"DLIiq","top":"VpbuX","star":"closc","roundStar":"fQl5T"};